import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import axios from '../../utils/axios';
import { primaryLambdaGateway } from '../../utils/apiEndpointUtility';

import {
	processCardInfo,
	processCardInfoCompleted,
	processCardInfoFailed
} from './processCardInfoSlice';

export const processCardInfoEpic = (action$) =>
	action$.pipe(
		ofType(processCardInfo),
		mergeMap(async (action) => {
			const payload = action.payload;

			const response = await axios.post(
				`${primaryLambdaGateway()}/savvy/payments/cardUpdater`,
				JSON.stringify(payload)
			);
			return response.data;
		}),
		switchMap((response) => [processCardInfoCompleted(response)]),
		catchError((error, source) =>
			merge(of(processCardInfoFailed(error.message)), source)
		)
	);

export default [processCardInfoEpic];
